import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUnitMeasurements, createUnitMeasurements, deleteUnitMeasurement, updateUnitMeasurements } from '../../service/api';

// Buscar todas as unidades de medida
export const fetchAllUnitMeasurements = createAsyncThunk(
  'unit_measurement/fetchAllUnitMeasurements',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUnitMeasurements();
      // console.log("Retorno Action Unidades de Medidas: " + JSON.stringify(response))
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao buscar unidades de medida');
    }
  }
);

// Criar uma nova unidade de medida
export const createNewUnitMeasurement = createAsyncThunk(
  'unit_measurement/createNewUnitMeasurement',
  async (unitMeasurements, { rejectWithValue }) => {
    try {
      const response = await createUnitMeasurements(unitMeasurements);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao criar unidade de medida');
    }
  }
);

// Update consultation_types
export const updateUnitMeasurementsById = createAsyncThunk(
  'unit_measurement/updateUnitMeasurementsById', // 👈 também corrigi o prefixo errado aqui
  async ({ unit_measurement_id, ...data }, { rejectWithValue }) => {
    try {
      const response = await updateUnitMeasurements(unit_measurement_id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao atualizar unidade de medida');
    }
  }
);

export const deleteUnitMeasurementById = createAsyncThunk(
  'consultations/deleteUnitMeasurementById',
  async (unit_measurement_id) => {
    const response = await deleteUnitMeasurement(unit_measurement_id);
    return {
      id: unit_measurement_id,
      message: response.message,
    };
  }
);
